module.exports = __webpack_public_path__ + "img/pdf.9d8ac74a.png";